"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postErrorResponse = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.postErrorResponse = typebox_1.Type.Object({
    success: typebox_1.Type.Boolean({ default: false }),
    title: typebox_1.Type.String({ description: 'Error title' }),
    detail: typebox_1.Type.String({ description: 'Detailed error message' }),
}, {
    description: 'Error response for Post Event',
    examples: [
        {
            success: false,
            title: 'Validation Error',
            detail: 'The provided input is invalid.',
        },
        {
            success: false,
            title: 'Internal Server Error',
            detail: 'An unexpected error occurred.',
        },
    ],
});
//# sourceMappingURL=post-error-response.js.map